import _ from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectSlackWorkspace } from "../../../slice/selectors";
import { UpgradeBanner } from "../../UpgradeBanner";
import { FileUpload } from '../Components/FileUpload';
import { useAppCustomizationsPanelSlice } from '../slice';
import {
  selectCustomizationStateCopy,
  selectShoutBannerMultipleUser,
} from '../slice/selectors';
import { Banner } from '../slice/types';

const Title = styled.span<{}>`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

const Description = styled.span<{}>`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

const Image = styled.img`
  width: 100%;
`;

const Radio = styled.input`
  height: 20px;
  width: 20px;
`;

const BannerList = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export enum BANNER_TYPE {
  CUSTOM,
  DEFAULT,
}

export const ShoutoutCustomization = () => {
  const currentMultipleUserBanner = useSelector(selectShoutBannerMultipleUser);
  const stateCopy = useSelector(selectCustomizationStateCopy);
  const { shoutOutBannerMultipleUser } = stateCopy;
  const dispatch = useDispatch();
  const { actions } = useAppCustomizationsPanelSlice();
  const slackWorkspace = useSelector(selectSlackWorkspace);

  const onNewBannerUpload = (url: string) => {
    const previousBanners =
      shoutOutBannerMultipleUser && shoutOutBannerMultipleUser.length
        ? shoutOutBannerMultipleUser
        : [];
    const updatedShoutMultiUserBanners: Array<Banner> = [
      ...previousBanners.map(item => ({ ...item, isActive: false })),
      { url, isActive: true },
    ];
    dispatch(
      actions.setStateCopy({
        ...stateCopy,
        shoutOutBannerMultipleUser: updatedShoutMultiUserBanners,
      }),
    );
    dispatch(actions.setIsDataChanged(true));
  };

  const onSelectBanner = (url: string) => {
    let updatedBanners =
      shoutOutBannerMultipleUser && shoutOutBannerMultipleUser.length
        ? shoutOutBannerMultipleUser
        : [];
    if (url === '') {
      updatedBanners = updatedBanners.map(item => ({
        ...item,
        isActive: false,
      }));
      dispatch(
        actions.setStateCopy({
          ...stateCopy,
          shoutOutBannerMultipleUser: updatedBanners,
        }),
      );
    } else {
      updatedBanners = updatedBanners.map(item => {
        return { ...item, isActive: item.url === url ? true : false };
      });
      dispatch(
        actions.setStateCopy({
          ...stateCopy,
          shoutOutBannerMultipleUser: updatedBanners,
        }),
      );
    }
    if (!_.isEqual(updatedBanners, currentMultipleUserBanner)) {
      dispatch(actions.setIsDataChanged(true));
    } else {
      dispatch(actions.setIsDataChanged(false));
    }
  };
  return (
    <>
      <UpgradeBanner enabled={!slackWorkspace?.entitlements.celebrations.customBanner}/>
      <Description>
        Upload custom banners to make it special and unique to your
        organization. We recommend PNG or JPG at 1280x 650px.
      </Description>

      <Title>Shoutout Banner (2+ people)</Title>
      <BannerList>
        <div>
          <Radio
            type="radio"
            value={BANNER_TYPE.DEFAULT}
            name="default"
            checked={
              !shoutOutBannerMultipleUser ||
              !shoutOutBannerMultipleUser.find(item => item.isActive)
            }
            onClick={() => onSelectBanner('')}
          />
        </div>
        <div>
          <Image src={`${location.origin}/shoutouts/banner.png`} />
        </div>
      </BannerList>
      {shoutOutBannerMultipleUser &&
        shoutOutBannerMultipleUser.map(item => (
          <BannerList>
            <div>
              <Radio
                type="radio"
                value={item.url}
                checked={item.isActive}
                onClick={() => onSelectBanner(item.url)}
              />
            </div>
            <div>
              <Image src={item.url} />
            </div>
          </BannerList>
        ))}
      <FileUpload onFileUpload={onNewBannerUpload}
                  disabled={!slackWorkspace?.entitlements.celebrations.customBanner}
      />
    </>
  );
};
